export default __webpack_public_path__ + "static/media/see-detail-icon.af0970eb.svg";